<template>
    <div v-if="placeData" class="place container">
        <h3>{{placeData.name}}</h3>
        <maps />
    </div>
</template>
<script>
import db from "@/firebase/init"
import maps from './Maps'
export default {
    name:"Place",
    components:{
        maps
        
    },
    data(){
        return{
            placeData:null
        }
    },

    created(){
        let ref = db.collection("places")
        ref.doc(this.$route.params.id).get()
        .then((place) => {
            this.placeData = place.data()
            
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Map.vue